import template from './foodBenefitRouting.html';
import controller from './foodBenefitRouting.controller';
import './foodBenefitRouting.scss';

let foodBenefitRoutingComponent = {
  restrict: 'E',
  bindings: {
    moduleClosed: '<'
  },
  template,
  controller
};

export default foodBenefitRoutingComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitRouting/foodBenefitRouting.component.js